export default String.raw`
{% assign logisticsPartners = config.Banners['LogisticsPartners'].Images -%}
{% assign paymentOperators = config.Banners['PaymentOperators'].Images -%}

{% assign logisticsPartnersSize = logisticsPartners | Size -%}
{% assign paymentOperatorsSize = paymentOperators | Size -%}

<footer class="footer footer-js">
    {% assign footerSectionSize = config.Footer.Sections | Size -%}
    <div class="footer__wrapper footer__main {% if footerSectionSize > 4 -%} more-columns {% endif -%}">
        {% assign baseHref = page.BaseHref -%}
        {% for section in config.Footer.Sections -%}
            {% assign index = forloop.index -%}
            <div class="footer__section">
                <div class="footer__section-title switch footer-section-title-js">
                    <span>{{ section.Heading }}</span>
                    <svg aria-label="{{translations.RollOutEverything}}" role="button" tabindex="0" height="24" width="24" class="footer__section-arrow footer-section-arrow-js">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}"></use>
                    </svg>
                </div>
                <ul class="footer__section-content footer__section-content to-hide footer-section-content-js">
                    {% for page in section.Pages -%}
                        <li class="footer__section-link">
                            {% if page.Id == config.DefinedPages.Terms.Id or page.Id == config.DefinedPages.Privacy.Id or page.Id == config.DefinedPages.PasswordReminder.Id -%}
                                {% capture footerPageHref -%}{% include 'partials/common/user-link.html', userLink: page.Url, userBase: baseHref -%}{% endcapture -%}
                                <a href="{{ footerPageHref }}" rel="nofollow">{{page.Name}}</a>
                            {% elseif page.Id == config.DefinedPages.CustomerProfile.Id and usr.Authenticated == 'true' -%}
                                <a {% if config.B2B -%} href="{{ baseHref }}{{ config.DefinedPages.CustomerProfile.Url }}?tab=eshop-orders" {% else -%} href="{{ baseHref }}{{ config.DefinedPages.CustomerProfile.Url }}?tab=active-orders" {% endif -%} rel="nofollow">{{ page.Name }}</a>
                            {% elseif page.Id == config.DefinedPages.AdvancedSearch.Id -%}
                                <a class="advanced-search-link" href="{{ baseHref }}{{config.DefinedPages.AdvancedSearch.Url}}" rel="nofollow">{{ page.Name }}</a>
                            {% elseif page.Id == config.DefinedPages.Login.Id or page.Id == config.DefinedPages.Registration.Id -%}
                                {% unless page.Id == config.DefinedPages.Registration.Id and config.Registration.Disabled -%}
                                    {% if usr.Authenticated == 'true' -%}
                                        <a {% if config.B2B -%} href="{{ baseHref }}{{ config.DefinedPages.CustomerProfile.Url }}?tab=eshop-orders" {% else -%} href="{{ baseHref }}{{ config.DefinedPages.CustomerProfile.Url }}?tab=active-orders" {% endif -%} rel="nofollow">{{ page.Name }}</a>
                                    {% else -%}
                                        {% if page.Url != null and page.Url != '' %}{% capture aHref -%}{% include 'partials/common/user-link.html', userLink: page.Url, userBase: baseHref -%}{% endcapture -%}{% assign aHrefAttr = 'href="' | Append: aHref | Append: '"' %}{{ page | A | Replace: 'href="[^"]*"', aHrefAttr }}{% else %}{{ page | A }}{% endif %}
                                    {% endif -%}
                                {% endunless -%}
                            {% else -%}
                                {% if page.Url != null and page.Url != '' %}{% capture aHref -%}{% include 'partials/common/user-link.html', userLink: page.Url, userBase: baseHref -%}{% endcapture -%}{% assign aHrefAttr = 'href="' | Append: aHref | Append: '"' %}{{ page | A | Replace: 'href="[^"]*"', aHrefAttr }}{% else %}{{ page | A }}{% endif %}
                            {% endif -%}
                        </li>
                    {% endfor -%}
                </ul>
            </div>
        {% endfor -%}
        <div class="footer__section contact-section">
            <div class="footer__section-title">
                {{ translations.Contact }}
                <div class="footer__section-arrow"></div>
            </div>
            <ul class="footer__section-content">
                <li class="footer__section-info">
                    {% if config.Shop.Contact.Email != '' -%}
                        <svg height="24" width="24" class="footer__icon">
                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#envelope-{{settings.iconStyle}}"></use>
                        </svg>
                        <a aria-label="{{ translations.EmailAddress }} {{ config.Shop.Contact.Email }}" href="mailto:{{config.Shop.Contact.Email}}">{{ config.Shop.Contact.Email }}</a>
                    {% endif -%}
                </li>    
                <li class="footer__section-info">
                    {% if config.Shop.Contact.PhoneNo != '' -%}
                        <svg height="24" width="24" class="footer__icon">
                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#headset-{{settings.iconStyle}}"></use>
                        </svg>
                        <a aria-label="{{ translations.PhoneNumber }} {{ config.Shop.Contact.PhoneNo }}" href="tel:{{config.Shop.Contact.PhoneNo | Split: ' ' | Join: ''}}">{{config.Shop.Contact.PhoneNo}}</a>
                    {% endif -%}
                </li>
                <li class="footer__section-info">
                    {% if config.Shop.Contact.PhoneNo2 != '' -%}
                        <svg height="24" width="24" class="footer__icon">
                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#headset-{{settings.iconStyle}}"></use>
                        </svg>
                        <a aria-label="{{ translations.PhoneNumber }} 2 {{config.Shop.Contact.PhoneNo2}}" href="tel:{{config.Shop.Contact.PhoneNo2 | Split: ' ' | Join: ''}}">{{config.Shop.Contact.PhoneNo2}}</a>
                    {% elseif config.Shop.Contact.GSM != '' -%}
                        <svg height="24" width="24" class="footer__icon">
                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#mobile-{{settings.iconStyle}}"></use>
                        </svg>
                        <a aria-label="{{ translations.PhoneNumber }} {{ config.Shop.Contact.GSM }}" href="tel:{{config.Shop.Contact.GSM | Split: ' ' | Join: ''}}">{{config.Shop.Contact.GSM}}</a>
                    {% elseif config.Shop.Contact.Fax != '' -%}
                        <svg height="24" width="24" class="footer__icon">
                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#print-{{settings.iconStyle}}"></use>
                        </svg>
                        <a aria-label="Fax {{config.Shop.Contact.Fax}}" href="fax:{{config.Shop.Contact.Fax | Split: ' ' | Join: ''}}">{{config.Shop.Contact.Fax}}</a>
                    {% elseif config.Shop.Contact.Skype != '' -%}
                        <svg height="24" width="24" class="footer__icon">
                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#skype"></use>
                        </svg>
                        <a aria-label="Skype {{config.Shop.Contact.Skype}}" href="skype:{{config.Shop.Contact.Skype}}?chat">{{config.Shop.Contact.Skype}}</a>
                    {% endif -%}
                </li>
            </ul>
            <div class="footer__section-title hide-on-mobile">
                {{ translations.YouWillFindUsOn }}
            </div>
            <div class="footer__section-social">
                {{ config.Footer.JoinUs }}
            </div>
        </div>
    </div>

    <div class="footer__wrapper footer__banners">
        {% if logisticsPartnersSize > 0 -%}
            <div class="footer__banner">
                <div class="footer__banner-title">{{ translations.LogisticsPartnersBannerTitle }}</div>
                <div class="footer__banner-content">
                    {% for img in logisticsPartners -%}
                        <div class="footer__banner-img">
                            {% if img.Link != '' -%}
								{% capture imgHref -%}{% include 'partials/common/user-link.html', userLink: img.Link -%}{% endcapture -%}
								<a href="{{ imgHref }}" {% if img.TargetBlank == true -%} target="blank" {% endif -%}>
							{% endif -%}
									<img alt="{{img.Alt | H}}" src="css/img/alo.gif" data-src="{{img.Url}}">
							{% if img.Link != '' -%}
								</a>
							{% endif -%}
                        </div>
                    {% endfor -%}
                </div>
            </div>
        {% endif -%}
        {% if paymentOperatorsSize > 0 -%}
            <div class="footer__banner">
                <div class="footer__banner-title">{{ translations.PaymentOperatorsBannerTitle }}</div>
                <div class="footer__banner-content">
                    {% for img in paymentOperators -%}
                        <div class="footer__banner-img">
                            {% if img.Link != '' -%}
								{% capture imgHref -%}{% include 'partials/common/user-link.html', userLink: img.Link -%}{% endcapture -%}
								<a href="{{ imgHref }}" {% if img.TargetBlank == true -%} target="blank" {% endif -%}>
							{% endif -%}
									<img alt="{{img.Alt | H}}" src="css/img/alo.gif" data-src="{{img.Url}}">
							{% if img.Link != '' -%}
								</a>
							{% endif -%}
                        </div>
                    {% endfor -%}
                </div>
            </div>
        {% endif -%}
    </div>

    <div class="footer__wrapper footer__copyright">
        <div class="footer__copyright-content">
            {% assign year = config.Now | Date : "yyyy" -%}

            {% assign dataString = '' -%}
                    
            {% if config.Shop.Name != '' -%}
                {% assign dataString = dataString | Append: config.Shop.Name  -%}       
                
                {% if config.Shop.Address.Street != '' or config.Shop.Address.StreetNo != '' or config.Shop.Address.ZipCode != '' or config.Shop.Address.City != '' or config.Shop.Address.Country != '' or config.Shop.Registrant != '' or config.Shop.TIN != '' or config.Shop.Regon != '' -%}
                    {% assign dataString = dataString | Append: ', '  -%}       
                {% endif -%}
            {% endif -%}

            {% if config.Shop.Address.Street != '' -%}
                {% assign dataString = dataString | Append: config.Shop.Address.Street | Append: ' ' -%}
            {% endif -%}

            {% if config.Shop.Address.StreetNo != '' -%}
                {% if config.Shop.Address.UnitNo != '' -%}
                    {% assign dataString = dataString | Append: config.Shop.Address.StreetNo / config.Shop.Address.UnitNo -%} 
                {% else -%}
                    {% assign dataString = dataString | Append: config.Shop.Address.StreetNo -%} 
                {% endif -%}

                {% if config.Shop.Address.ZipCode != '' or config.Shop.Address.City != '' or config.Shop.Address.Country != '' or config.Shop.Registrant != '' or config.Shop.TIN != '' or config.Shop.Regon != '' -%}
                    {% assign dataString = dataString | Append: ', ' -%}       
                {% endif -%}
            {% endif -%}

            {% if config.Shop.Address.ZipCode != '' -%}
                {% assign dataString = dataString | Append: config.Shop.Address.ZipCode -%} 
                        
                {% if config.Shop.Address.City != '' or config.Shop.Address.Country != '' or config.Shop.Registrant != '' or config.Shop.TIN != '' or config.Shop.Regon != '' -%}
                    {% assign dataString = dataString | Append: ', ' -%}       
                {% endif -%}
            {% endif -%}

            {% if config.Shop.Address.City != '' -%}
                {% assign dataString = dataString | Append: config.Shop.Address.City -%} 

                {% if config.Shop.Address.Country != '' or config.Shop.Registrant != '' or config.Shop.TIN != '' or config.Shop.Regon != '' -%}
                    {% assign dataString = dataString | Append: ', ' -%}       
                {% endif -%}
            {% endif -%}

            {% if config.Shop.Address.Country != '' -%}
                {% assign dataString = dataString | Append: config.Shop.Address.Country -%} 

                {% if config.Shop.Registrant != '' or config.Shop.TIN != '' or config.Shop.Regon != '' -%}
                    {% assign dataString = dataString | Append: ', ' -%}       
                {% endif -%}
            {% endif -%}

            {% if config.Shop.Registrant != '' -%}
                {% assign dataString = dataString | Append: config.Shop.Registrant -%} 

                {% if config.Shop.TIN != '' or config.Shop.Regon != '' -%}
                    {% assign dataString = dataString | Append: ', ' -%}       
                {% endif -%}
            {% endif -%}

            <p>
                {{ dataString }}

                {% if config.Shop.TIN != '' -%}
                    {% if config.Shop.Regon != '' -%}
                        {{ translations.Prf_NIP }}: {{ config.Shop.TIN }},
                    {% else -%}
                        {{ translations.Prf_NIP }}: {{ config.Shop.TIN }}
                    {% endif -%}
                {% endif -%}

                {% if config.Shop.Regon != '' -%}
                    {{ translations.Prf_REGON }}: {{ config.Shop.Regon }}
                {% endif -%}
            </p>

            <p>
                {{ translations.Copyright  | Format: year }} <a href="{{config.Application.Website}}">{{config.Application.Name}} ®</a>
            </p>
        </div>
    </div>

	{% assign msgCounterF = 0 -%}
	{% for msg in config.Messages -%}
		{% assign msgCounterF = msgCounterF | Plus: 1 -%}
		{% if msg.Type == 1 -%}
			{% include 'partials/common/cookies-message.html', msgCounter: msgCounterF -%}
		{% endif -%}
	{% endfor -%}
</footer>
`